import React, { useEffect, useState } from 'react';
import { Phone, List, X, SignIn } from '@phosphor-icons/react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Pricing',
    href: '#cost'
  }, {
    name: 'Contact',
    href: '#lead'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-out-expo ${isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-hairline py-3' : 'bg-white py-4'}`} data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center gap-4" data-id="element-138">
        <a href="#" className="flex-shrink-0" data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/rgU1DXAoA6RwJEverEyBwn/logo-motto4x-1024x244.png" alt="Knight CFO, Bookkeeping and Payroll" className="h-9 sm:h-10 w-auto object-contain" data-id="element-140" />
        </a>

        <nav className="hidden xl:flex items-center gap-7" data-id="element-141">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-charcoal hover:text-knight-orange transition-colors duration-300 ease-out-expo" data-id="element-142">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden lg:flex items-center gap-4" data-id="element-143">
          <a href="tel:+61863179998" className="flex items-center text-charcoal hover:text-knight-orange font-semibold text-sm transition-colors" data-id="element-144">
            <Phone size={16} weight="regular" className="mr-2" data-id="element-145" />
            <span className="font-mono" data-id="element-146">+61 8 6317 9998</span>
          </a>
          <a href="#lead" className="bg-knight-orange hover:bg-knight-orange-hover text-white px-5 py-2.5 rounded-md font-semibold text-sm transition-colors duration-300 ease-out-expo" data-id="element-147">
            Book a Free Consultation
          </a>
        </div>

        <button className="lg:hidden p-2 text-charcoal -mr-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-148">
          {mobileMenuOpen ? <X size={24} weight="regular" data-id="element-149" /> : <List size={24} weight="regular" data-id="element-150" />}
        </button>
      </div>

      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-b border-hairline py-4 px-4 flex flex-col gap-1" data-id="element-151">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-charcoal py-3 border-b border-hairline" onClick={() => setMobileMenuOpen(false)} data-id="element-152">
              {link.name}
            </a>)}
          <div className="pt-4 flex flex-col gap-3" data-id="element-153">
            <a href="tel:+61863179998" className="flex items-center justify-center w-full border border-hairline text-charcoal py-3 rounded-md font-medium" data-id="element-154">
              <Phone size={16} weight="regular" className="mr-2" data-id="element-155" />
              <span className="font-mono" data-id="element-156">+61 8 6317 9998</span>
            </a>
            <a href="#lead" className="flex items-center justify-center w-full bg-knight-orange text-white py-3 rounded-md font-semibold" onClick={() => setMobileMenuOpen(false)} data-id="element-157">
              Book a Free Consultation
            </a>
          </div>
        </div>}
    </header>;
}